import DollarsignCircleBold from './DollarsignCircleBold';

export default DollarsignCircleBold;
